import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { Col, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API_ROUTE_CONTROLLER } from "../../../app/base/routes";
import { ApiServices } from "../../../app/base/service/apiService";
import { validator } from "../../../app/base/utils";
import { paymentserviceNumbersStep1Result } from "../../../store/login";
import { setPlanDetails } from "../../../store/paymentservice";
import { setDataEnterFromAddCardUpdate } from "../../../store/user";
import allcards from "../../styles/images/allcard.svg";
import masterlogo from "../../styles/images/masterlogo.svg";
import Loaders from "../../loader";
import styles from "../scss/upgradedetails.module.scss";

import { COUNTRY } from "../../../service/constant";
import Stripe from "../../../stripe_payment";
import ToastError from "../../toastError";


const ChatBotPlanDetailsBot = (props: any) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state: any) => state.user);
    console.log("user------", user, props, user?.paymentBotData?.detail?.companyId)
    const login = useSelector((state: any) => state.login.login);
    const loginCred = useSelector((state: any) => state.login.loginCred);
    const product = useSelector((state: any) => state.constant.products);
    console.log("product-------", product)
    console.log("inffffffff", user)
    const options = [
        { value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' }
    ]
    const [modalShow, setmodalShow] = useState(false);
    const [modalShownew, setmodalShownew] = useState(false);
    const handleClose = () => setmodalShow(false);
    const [licenseUser, setLicenseUser] = useState<any>(0);
    const handleShow = (row) => { setmodalShow(true) };
    const handleClosenew = () => setmodalShownew(false);
    const handleShownew = () => { setDataEnterFromAddCardUpdate({}); setmodalShownew(true); setCardNumber(""); setMonth(""); setYear(""); }

    const [savedCardDetails, setSavedCardDetails] = useState<any>([]);
    const [getCountryListData, setCountryListData] = useState([]);
    const [formErrors, setFormErrors] = useState<any>({});
    //calucaltion
    const [licenseduser, setLicensedUser] = useState(user?.getPlanInfo[0]?.min_user)
    const [vat, setVat] = useState<any>(0)
    const [setUpFee, SetsetUpFee] = useState<any>(localStorage.getItem("isSetUpFee"));
    const [getLicenseUserErr, setLicenseUserErr] = useState<any>("");
    const [total, setTotal] = useState(0)
    console.log("Total", total)
    const [ip, setIP] = useState<any>('')
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [vatCal, setValCal] = useState<any>(0)
    const [totalCal, setTotalCal] = useState<any>(0)
    const [subTotalCal, setSubTotalCal] = useState<any>(0)
    const [paidUsers, setpaidUsers] = useState<any>(0)
    const [AddedNewcard, IsAddNewCard] = useState(false)
    const [isCheckError, setIsCheckError] = useState(false)
    const [getAValue, setAValue] = useState<any>(0);
    const [getBValue, setBValue] = useState<any>(0);
    const [getfinalcal, setfinalcal] = useState<any>(0);
    const [getFinalDate, setFinalDate] = useState<any>('');
    const [isChecked, setIsChecked] = useState(false);
    const [authIsChecked, setAuthIsChecked] = useState(false);
    const [isChecked1, setIsChecked1] = useState(false);
    const [isRadioChecked, setIsRadioChecked] = useState(false);
    const [isGetValue, setIsGetValue] = useState(0);
    const [cardNumber, setCardNumber] = useState("");
    const [getMonth, setMonth] = useState("");
    const [getYear, setYear] = useState("");
    const [planPric, setplanPric] = useState<any>(0)
    const [isLoader, setLoader] = useState<boolean>(false);
    const [userDetailsCount, setUserDetailsCount] = useState<any>(0);
    const [userBaiscCount, setUserBaiscCount] = useState<any>(0);
    const [isShopifyRedirectModal, setShopifyRedirectModal] = useState<boolean>(false)
    const [installationCost, setInstallationCost] = useState<any>(localStorage.getItem("installationCost"));
    const [planName, setPlanName] = useState<any>("");
    const [cardStatus, setCardStatus] = useState('');
    const payment = useSelector((state: any) => state.payment);
    console.log("payment", payment)
    const paymentStep1Resp: any = useSelector((state: any) => state.login.paymentStep1Resp);
    console.log("paymentStep1Resp", paymentStep1Resp)
    const paymentStep2Resp: any = useSelector((state: any) => state.login.paymentStep2Resp);
    const paymentservice: any = useSelector((state: any) => state.login.paymentCardDetails);
    const _loginCred = useSelector((state: any) => state.login.loginCred);
    const current = useSelector((state: any) => state.user);
    let discountNew = 0.5455;
    let newcomp = Math.round((
        (parseInt(user?.getPlanInfo[0].platform_fee) +
            parseInt(user?.getPlanInfo[0].Installation_cost) -
            (parseInt(user?.getPlanInfo[0].platform_fee) * discountNew)) * 0.2
    )) + Math.round((
        parseInt(user?.getPlanInfo[0].platform_fee) +
        parseInt(user?.getPlanInfo[0].Installation_cost) -
        (parseInt(user?.getPlanInfo[0].platform_fee) * discountNew)
    ))


    const products = useSelector((state: any) => state.constant.products);
    const _compId = useSelector((state: any) => state.login.login);
    const [paymentModal, setPaymentModal] = useState(false)
    const handleCheckboxChange = (event) => {
        setAuthIsChecked(event.target.checked)
    };
    const navigation = () => {
        setUpFee === "1" ?
            navigate('/subscription-management')
            :
            navigate('/subscription-management/chatbotupgradepage')
    }





    // const handleSelectCard = () => {
    //     setIsRadioChecked(true)
    //     if (isChecked === true) {
    //         setIsGetValue(1)
    //         setmodalShow(false)
    //     } else {
    //         alert("please select any one card")
    //     }
    // }

    const getCountryList = async () => {
        let _url = API_ROUTE_CONTROLLER.Urmyaccgetcountrylistinfo;
        await ApiServices.get(_url).then(res => {

            if (res) {
                setCountryListData(res.data.finalresponse);
                //console.log("getCountryList", res.data.finalresponse);
            }
        });
    }


    // const handleOpen = () => {
    //     const _url = API_ROUTE_CONTROLLER.Urmyaccountgetcccardinfo;
    //     const _body = {
    //         "company_id": user?.paymentBotData?.detail?.companyId
    //     };
    //     ApiServices.post(_body, _url).then(res => {
    //         setSavedCardDetails(res.data.finalresponse);
    //         setmodalShow(true);
    //     })
    // }

    // let values = {
    //     card_name: "",
    //     card_number: "",
    //     cvv: "",
    //     exp_date: "",
    //     address: "",
    //     country: "",
    //     city: "",
    //     exp_year: "",
    //     postcode: "",
    // }


    // const validate = (values: any) => {
    //     const errors: any = {};
    //     var ob = new validator;
    //     errors.card_name = ob.set(values.card_name)
    //         .required("Please enter the name on card")
    //         .msg;
    //     errors.card_number = ob.set(values.card_number)
    //         .required("Please enter card number")
    //         .msg;
    //     errors.exp_date = ob.set(values.exp_date)
    //         .required("Please select date")
    //         .msg;
    //     errors.exp_year = ob.set(values.exp_year)
    //         .required("Please select year")
    //         .msg;
    //     errors.address = ob.set(values.address)
    //         .required("Please enter the address")
    //         .msg;
    //     errors.country = ob.set(values.country)
    //         .required("Please enter the country")
    //         .msg;
    //     errors.city = ob.set(values.city)
    //         .required("Please enter the city")
    //         .msg;
    //     errors.postcode = ob.set(values.postcode)
    //         .required("Please enter the postcode")
    //         .msg;
    //     return errors;
    // };

    // const formatCardNumber = (value: any) => {
    //     const regex = /[^0-9]/g;
    //     const cleanedValue = value.replace(regex, '');
    //     const formattedValue = cleanedValue.replace(/(.{4})/g, '$1 ');
    //     return formattedValue.trim();
    // }

    // const handlecvv = (e) => {
    //     IsAddNewCard(false)
    //     setCvv(e.target.value)
    // }

    const currentYear = new Date().getFullYear();
    const futureYear = currentYear + 30;
    const yearOptions = Array.from({ length: futureYear - currentYear + 1 }, (_, index) => currentYear + index);
    // const handleChange = (e) => {
    //     const { name, value } = e.target;

    //     switch (name) {
    //         case "card_name":
    //             getValue.card_name = value.trim();
    //             break;
    //         case "card_number":
    //             getValue.card_number = value;
    //             setCardNumber(getValue.card_number.replace(/\D/g, '').replace(/(.{4})/g, '$1 ').trim())
    //             break;
    //         case "exp_date":
    //             getValue.exp_date = value;
    //             setMonth(value)
    //             break;
    //         case "exp_year":
    //             getValue.exp_year = value;
    //             setYear(value)
    //             break;
    //         case "address":
    //             getValue.address = value;
    //             break;
    //         case "country":
    //             getValue.country = value;
    //             break;
    //         case "city":
    //             getValue.city = value;
    //             break;
    //         case "postcode":
    //             getValue.postcode = value;
    //             break;
    //     }
    //     setFormErrors(validate(getValue));
    // };

    // function findDebitCardType(card_number) {
    //     const regexPattern = {
    //         MC: /^5[1-5][0-9]{1,}|^2[2-7][0-9]{1,}$/,
    //         Visa: /^4[0-9]{2,}$/,
    //         AMEX: /^3[47][0-9]{5,}$/,
    //         Discover: /^6(?:011|5[0-9]{2})[0-9]{3,}$/,
    //         Diners: /^3(?:0[0-5]|[68][0-9])[0-9]{4,}$/,
    //         Maestro: /^(?:5[0678]\d\d|6304|6390|67\d\d)\d{8,15}$/,
    //         JCB: /^(?:2131|1800|35[0-9]{3})[0-9]{3,}$/
    //     };
    //     for (const card in regexPattern) {
    //         if (card_number?.replaceAll(" ", "").match(regexPattern[card])) return card;
    //     }
    //     return "";
    // }



    // const handleStore = () => {
    //     IsAddNewCard(false)
    //     setIsSubmitted(true);
    //     setFormErrors(validate(getValue));
    //     if (submitForm()) {
    //         const dataEnter = {
    //             card_name: getValue.card_name,
    //             card_number: getValue.card_number,
    //             cvv: getValue.cvv,
    //             exp_date: getValue.exp_date,
    //             exp_year: getValue.exp_year,
    //             address: getValue.address,
    //             country: getValue.country,
    //             city: getValue.city,
    //             postcode: getValue.postcode,
    //             status: true
    //         }
    //         dispatch(setDataEnterFromAddCardUpdate({ dataEnter }))
    //         setmodalShownew(false)
    //         setmodalShow(false)
    //     }
    // }

    // const submitForm = () => {
    //     if (Object.keys(formErrors).length == 0) {
    //         return false;
    //     }

    //     let flag = true;
    //     let hasFalse = Object.keys(formErrors).some((keyName) => {
    //         if (formErrors[keyName]) {
    //             flag = false;
    //         }
    //     });

    //     return flag;
    // };

    const getSavedCard = () => {
        const _url_grid_data = API_ROUTE_CONTROLLER.Urmyaccountgetcccardinfo;
        const _body_grid_data = {
            "company_id": user?.paymentBotData.detail.companyId
        };
        ApiServices.post(_body_grid_data, _url_grid_data).then(res => {
            setSavedCardDetails(res.data.finalresponse);
            if (res.data.finalresponse.length == 0 && (user?.getDataEnterFromAddCardUpdate?.dataEnter?.status === false || Object.keys(user?.getDataEnterFromAddCardUpdate).length === 0)) {
                IsAddNewCard(true)
            }

            res.data.finalresponse.map((item => {
                if (item.is_card_default_desc == 'Primary card') {
                    setInFrom(item)
                }
            }))
            setmodalShow(false);
        })
    }

    const handleLicenseUser = (e) => {
        setLicensedUser(e.target.value)
        var vatCal = (parseInt(user?.getPlanInfo[0].platform_fee)) * 0.2
        setTotal(vatCal + ((parseInt(user?.getPlanInfo[0].platform_fee))))

    }

    const getBillServicePlan = async () => {

        const _url = API_ROUTE_CONTROLLER.UrgetBillServicePlan;
        const _body = {
            "company_id": user?.paymentBotData?.detail?.companyId,
        };
        const res = await ApiServices.post(_body, _url);
        return res.data;
    };


    const totalCalculation = (userCount: any) => {
        let planPricing: any;
        localStorage.setItem("paidUser", userCount)
        setpaidUsers(localStorage.getItem("paidUser"));
        setplanPric(localStorage.getItem("planPricing"));
        const pri: any = localStorage.getItem("planPricing");
        let _total: any = pri * userCount;
        let _total_without_pro

        let _vat: any = (_total_without_pro * 0.2);
        console.log("_vat", _vat, _total_without_pro)
        setValCal(_vat)
        let _finalPrice: any = ((_total_without_pro * 0.2) + _total_without_pro).toFixed(2);
        setTotalCal(_finalPrice)
        localStorage.setItem(" ", _finalPrice)
        localStorage.setItem("vat", _vat)
        localStorage.setItem("total", _finalPrice)
        localStorage.setItem("total_plan_amount", _total_without_pro)

        let growthtoenterpvat = (getfinalcal * 0.2).toFixed(2);
        setSubTotalCal(growthtoenterpvat)
    }

    let userMax: any = 0
    let userMin: any = 0
    if (typeof window !== "undefined") {
        userMax = 100;
        userMin = 1
    }

    const [maxUserPlan, setMaxUserPlan] = useState<any>(userMax)
    const [minUserPlan, setMinUserPlan] = useState<any>(1)
    const [platform_fee, setPlatform_fee] = useState<any>('');
    const validate1 = (values: any) => {
        let { value, min, max } = values;
        const ob = new validator();
        ob.setMinMax(value, min, max)
            .minCheck(`Minimum ${min} users required`);
        return ob.msg === "" ? true : false;
    };


    const onKeyPressEvent = (event: any) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        if (!new RegExp("[0-9]").test(keyValue)) event.preventDefault();
        return;
    };

    const onLicenseUserChange = async (e: any) => {
        localStorage.setItem('plan_upgraded3', 'Adding User')

        console.log("eeeeee", e.target.value)
        if (e.charCode != 8 && e.charCode == 0 || (e.charCode >= 48 && e.charCode <= 57)) {
            return false
        }

        if (e.target.value.startsWith('0')) {
            // Remove the leading zero
            e.target.value = e.target.value.slice(1);
        }
        let valid = validate1(e.target)
        let { value, min, max } = e.target;
        if (valid) {
            if (parseInt(value) > parseInt(max)) {
                setLicenseUser(max)
                totalCalculation(max)
            } else {
                totalCalculation(value)
                setLicenseUser(value)
            }
        } else {
            setLicenseUser(value)
        }
        setLicensedUser(e.target.value)
        const billServicePlan = await getBillServicePlan();
        localStorage.setItem("previousplanid", billServicePlan.result[0].plan_id)
        localStorage.setItem("previousplanprice", billServicePlan.result[0].current_plan_price)

        const nextBillDate = billServicePlan.result[0].bill_cycle.split("-")
        localStorage.setItem("nextbilldate", nextBillDate[1].trim())
        const dur1: any = localStorage.getItem("duration") == "1 month";
        const dur12: any = localStorage.getItem("duration") == "12 months";

        if (product[0].Is_free_trail == 1) {
            if (isChecked1 == true) {
                if (user?.getPlanInfo[0].cop_description == '1 month') {
                    var vatCal = (parseInt(user?.getPlanInfo[0].platform_fee)) * 0.2
                    setTotal(vatCal + (parseInt(user?.getPlanInfo[0].platform_fee)))
                } else if (user?.getPlanInfo[0].cop_description == '12 months') {
                    var vatCal = (user?.getPlanInfo[0].price2 * ((parseInt(e.target.value ? e.target.value : 0) + 1) + parseInt(userBaiscCount))) * 0.2
                    console.log("vatCal: " + vatCal)
                    setTotal(vatCal + (parseInt(user?.getPlanInfo[0].platform_fee)))
                }
            } else if (isChecked1 == false) {
                if (user?.getPlanInfo[0].cop_description == '1 month') {
                    var vatCal = (parseInt(user?.getPlanInfo[0].platform_fee)) * 0.2
                    setTotal(vatCal + (parseInt(user?.getPlanInfo[0].platform_fee)))
                } else if (user?.getPlanInfo[0].cop_description == '12 months') {
                    var vatCal = (parseInt(user?.getPlanInfo[0].platform_fee)) * 0.2
                    console.log("vatCal: " + vatCal)
                    setTotal(vatCal + (parseInt(user?.getPlanInfo[0].platform_fee)))
                }

            }
        }


        if (user?.getPlanInfo[0].tier_id && dur1 && product[0].Is_free_trail == 0) {
            console.log("duration1 month")
            const getEnterpriceUser: any = localStorage.getItem("minimumUsers");
            const getEnterpriceAmt: any = localStorage.getItem("planPricing");
            const previousUserCount: any = localStorage.getItem("previousUserCount");
            const getPreviUserCount: any = previousUserCount;
            setAValue(parseInt(licenseUser))
            const getPreviPlanPrice: any = localStorage.getItem("previousplanprice");
            const date122: any = localStorage.getItem("nextbilldate");
            const targetDate: any = new Date(date122);
            const currentDate: any = new Date();
            const diffInMs: any = targetDate.getTime() - currentDate.getTime();
            const diffInDays: any = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
            console.log("diffInDaysdiffInDays123", diffInDays, getPreviUserCount, getPreviPlanPrice);
            const b: any = ((((parseInt(getPreviUserCount)) * parseInt(getPreviPlanPrice)) / 30) * diffInDays)
            setBValue(b)
            if (isChecked1 == true) {
                console.log("bbbbbbbbbbbb", b, user?.getPlanInfo[0].price1, parseInt(e.target.value ? e.target.value : 0), userBaiscCount)
                const vatCal: any = (parseInt(user?.getPlanInfo[0].platform_fee))
                console.log("vatCalvatCal", vatCal)
                const vatCal1: any = ((parseInt(vatCal)) * 0.2)
                console.log("vatCal: " + vatCal1)
                //setVat(vatCal1)
                let total1 = user?.getPlanInfo[0].price1 * (parseInt(e.target.value ? e.target.value : 0) + parseInt(userBaiscCount ? userBaiscCount : 0))
                console.log("total1", total1)
                setTotal(vatCal1 + parseInt(vatCal))
            } else if (isChecked1 == false) {
                console.log("bbbbbbbbbbbb", b, user?.getPlanInfo[0].price1, parseInt(e.target.value ? e.target.value : 0), userBaiscCount)
                const vatCal: any = (parseInt(user?.getPlanInfo[0].platform_fee))
                console.log("vatCalvatCal", vatCal)
                const vatCal1: any = ((parseInt(vatCal)) * 0.2)
                console.log("vatCal: " + vatCal1)
                //setVat(vatCal1)
                let total1 = user?.getPlanInfo[0].price1 * (parseInt(e.target.value ? e.target.value : 0))
                console.log("total1", total1)
                setTotal(vatCal1 + parseInt(vatCal))
            }
        } else if (user?.getPlanInfo[0].tier_id && dur12 && product[0].Is_free_trail == 0) {
            console.log("duration12")
            const getEnterpriceUser: any = localStorage.getItem("minimumUsers");
            const getEnterpriceAmt: any = localStorage.getItem("planPricing");
            const previousUserCount: any = localStorage.getItem("previousUserCount");
            const getPreviUserCount: any = previousUserCount;
            setAValue(parseInt(licenseUser))
            const getPreviPlanPrice: any = localStorage.getItem("previousplanprice");
            const date122: any = localStorage.getItem("nextbilldate");
            const targetDate: any = new Date(date122);
            const currentDate: any = new Date();
            const diffInMs: any = targetDate.getTime() - currentDate.getTime();
            const diffInDays: any = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
            console.log("diffInDaysdiffInDays12345", diffInDays, getPreviUserCount, getPreviPlanPrice);
            const b: any = ((((parseInt(getPreviUserCount)) * parseInt(getPreviPlanPrice)) / 30) * diffInDays)
            setBValue(b)
            if (isChecked1 == true) {
                const vatCal: any = (parseInt(user?.getPlanInfo[0].platform_fee))
                const vatCal1: any = ((parseInt(vatCal)) * 0.2)
                //setVat(vatCal1)
                setTotal(vatCal1 + parseInt(vatCal))
            } else if (isChecked1 == false) {
                console.log("bbbbbbbbbbbb", b, user?.getPlanInfo[0].price2, parseInt(e.target.value ? e.target.value : 0))
                const vatCal: any = (parseInt(user?.getPlanInfo[0].platform_fee))
                console.log("vatCalvatCal", vatCal)
                const vatCal1: any = ((parseInt(vatCal)) * 0.2)
                console.log("vatCal: " + vatCal1)
                //setVat(vatCal1)
                setTotal(vatCal1 + parseInt(vatCal))
            }

        }

    }

    const user_type = async () => {
        let _url = API_ROUTE_CONTROLLER.Urdevicegetusertype;
        let _body = {
            "domain_id": user?.paymentBotData.detail.domainId,
        };
        const res = await ApiServices.post(_body, _url);
        for (let k = 0; k < res.data.finalresponse.length; k++) {
            if (res.data.finalresponse[k].user_type == 3) {
                setUserDetailsCount(res.data.finalresponse[k].tot_count);
                localStorage.setItem("previousUserCount", res.data.finalresponse[k].tot_count)
                let count: any = res.data.finalresponse[k].tot_count;
                setLicenseUser(0)
                if (user?.getPlanInfo[0].cop_description == '1 month') {
                    var vatCal = (user?.getPlanInfo[0]?.platform_fee) * 0.2
                    setVat(vatCal)
                    setTotal(vatCal + ((parseInt(user?.getPlanInfo[0].platform_fee))))
                } else if (user?.getPlanInfo[0].cop_description == '12 months') {
                    var vatCal = (user?.getPlanInfo[0]?.platform_fee) * 0.2
                    setVat(vatCal)
                    setTotal(vatCal + ((parseInt(user?.getPlanInfo[0].platform_fee))))
                }

            } else if (res.data.finalresponse[k].user_type == 1) {
                setUserBaiscCount(res.data.finalresponse[k].tot_count)
                localStorage.setItem("get_free_count", res.data.finalresponse[k].tot_count)
            }
        }
    };


    const getUserData = async () => {
        const res: any = await axios.get('https://getip.worktual.co.uk/');
        setIP(res.data.clientIPv6);
    }

    const NewProductPurchaseApi = async () => {
        const getPlanDuration: any = localStorage.getItem("duration")
        const _url = API_ROUTE_CONTROLLER.new_prod_purchaseApi;
        const _body = {
            "company_id": user?.paymentBotData?.detail?.companyId,
            "product_id": 15,
            "plan_id": 54,
            "plan_duration": getPlanDuration === "monthly" ? 1 : getPlanDuration === "12month" ? 12 : 0,
            "bundle_id": 0,
            "plan_price": 0,
            "reference_no": "test123",
            "plan_description": "new_product test",
            "adjustment_charge": 0,
            "tax_fee": 0,
            "tax_per": 0,
            "total_plan_charge": 0,
            "card_type": "visa",
            "expiry_date": 202412,
            "cc_number": "0077",
            "add_user_count": licenseUser,
            "upgrade_basic_user_count": 0,
            "p_free_trial": 0,
            "p_bill_duration": "string"
        }
        console.log("Body", _body)
        const res = await ApiServices.post(_body, _url);
        console.log("Response", res.data.sipGetcallparkslot[0].errmsg)
        if (res.data.sipGetcallparkslot[0].errmsg === "Success") {
            navigate("/overview");
        }
        return res;
    };

    // const getPaymentUpdateAccount = () => {
    //     let appURL = API_ROUTE_CONTROLLER.plan_sub_payment_fail
    //     let requestBody = {
    //         firstname: user?.getDataEnterFromAddCardUpdate.dataEnter.card_name,
    //         email: loginCred.email
    //     }
    //     ApiServices.post(requestBody, appURL).then(async (res) => { })

    // };


    const planUpgradeRequest = async (refId) => {
        const year = user?.getDataEnterFromAddCardUpdate?.dataEnter?.exp_year;
        const month = user?.getDataEnterFromAddCardUpdate?.dataEnter?.exp_date;
        const expiry = year && month ? `${year}${month}` : "202905";
        console.log("paymentpayment", payment)
        const checkBasicCount: any = localStorage.getItem("free_basic_count")
        const getBasicCount: any = localStorage.getItem("get_free_count")
        console.log("sdfsdfsdf", checkBasicCount, getBasicCount)
        let _url = API_ROUTE_CONTROLLER.Urmainsertplanchangerequest;
        let _body = {
            company_id: user?.paymentBotData?.detail?.companyId,
            product_id: product[0].product_id,
            plan_id: payment.planDetails.planId,
            plan_duration: user?.paymentBotData?.detail?.duration === "12 months" ? 12 : 1,
            bundle_id: 0,
            plan_price: payment.planDetails?.planPrice,
            reference_no: refId,
            plan_description: "",
            adjustment_charge: 0,
            tax_fee: vat,
            tax_per: 20,
            total_plan_charge: payment.planDetails.freeToPaid == "Yes" ? total - vat : total,
            card_type: "visa",
            expiry_date: expiry,
            cc_number: "0077",
            add_user_count: product[0].double_up == 1 ? (parseInt(payment.planDetails.licenseduser) * 2) : payment.planDetails.licenseduser,
            upgrade_basic_user_count: product[0].double_up == 1 ? (parseInt(payment.planDetails.licenseduser) * 2) : payment.planDetails.licenseduser,
            p_platform_user_fee: localStorage.getItem("platformfee"),
            p_platform_user_count: localStorage.getItem("conversationCount")
        };
        console.log("Urmainsertplanchangerequest", _body);
        ApiServices.post(_body, _url).then(async (res: any) => {
            if (res) {
                let hubData: any = {}
                if (payment.planDetails.freeToPaid == "Yes") {
                    let url = API_ROUTE_CONTROLLER.free_to_paid;
                    let body = {
                        "firstname": login.First_name,
                        "email": user?.paymentBotData?.detail?.email,
                        "plan_upgrade_date": new Date().toJSON().slice(0, 10),
                        "plan_upgrade_paid_amount": user?.paymentBotData?.detail?.companyId == 19538 ? newcomp : total,
                        "subscribed_plan_name": current.getPlanInfo[0]?.tier_name,
                        "type_of_contract_signed": (payment.planDetails.Duration == "12 Months" || payment.planDetails.Duration == "12 months") ? "Annual" : "Monthly rolling",
                        "billing_cycle": "Monthly",
                        "payment_reference_number": refId,
                        "region": COUNTRY?.region
                    }
                    await ApiServices.post(body, url)
                } else {
                    let url = API_ROUTE_CONTROLLER.upgrade_payment_success;
                    let body = {
                        "firstname": login.First_name,
                        "email": user?.paymentBotData?.detail?.email,
                        "plan_upgrade_date": new Date().toJSON().slice(0, 10),
                        "plan_upgrade_paid_amount": total - vat,
                        "subscribed_plan_name": current.getPlanInfo[0]?.tier_name,
                        "type_of_contract_signed": (payment.planDetails.Duration == "12 Months" || payment.planDetails.Duration == "12 months") ? "Annual" : "Monthly rolling",
                        "billing_cycle": "Monthly",
                        "payment_reference_number": paymentStep1Resp?.subscriptionId || paymentStep1Resp?.Ref_Id,
                        "region": COUNTRY?.region
                    }
                    await ApiServices.post(body, url)
                }
                let xml = `<invoice><breakup><category>Plan_Upgrade</category><description>${current.getPlanInfo[0]?.tier_name}</description><qty>${payment.planDetails.licenseduser}</qty><price>${payment.planDetails.planPrice}</price><vat_per>${vat}</vat_per><amount>${user?.paymentBotData?.detail?.companyId == 19538 ? newcomp : total}</amount><platform_fee>${user?.getPlanInfo[0]?.platform_fee}</platform_fee><setup_fee>0</setup_fee></breakup></invoice>`

                let _invoiceUrl = API_ROUTE_CONTROLLER.Urmyaccountcreateinvoicedetail;
                let _bodyContent = {
                    "company_id": user?.paymentBotData?.detail?.companyId,
                    "credit_avail_amount": 0,
                    "Sub_Total": total - vat,
                    "Payment_reference": refId,
                    "Vat_amount": vat,
                    "Total": user?.paymentBotData?.detail?.companyId == 19538 ? newcomp : total,
                    "prorata_adj": "0",
                    "Inv_breakup_xml": xml
                }
                await ApiServices.post(_bodyContent, _invoiceUrl)
                navigate('/payment_link_success')
            }
        }).catch(err => {
            console.log('err', err)
        })
    }


    const secondaryPlanUpgrade = async (refId) => {
        let _url = API_ROUTE_CONTROLLER.insert_secondary_plan_change_request;
        let _body = {
            "company_id": user?.paymentBotData?.detail?.companyId,
            "product_id": product[0].sec_prod_id,
            "plan_id": payment.planDetails.planId,
            "plan_duration": localStorage.getItem("duration") === "12 months" ? 12 : 1,
            "bundle_id": 0,
            "plan_price": payment.planDetails.planPrice,
            "reference_no": refId,
            "plan_description": "",
            "adjustment_charge": 0,
            "tax_fee": payment.planDetails.vatCal,
            "tax_per": 20,
            "total_plan_charge": payment.planDetails.total - payment.planDetails.vatCal,
            "card_type": "visa",
            "expiry_date": "202412",
            "cc_number": "0077",
            "add_user_count": product[0].double_up == 1 ? (parseInt(payment.planDetails.licenseduser) * 2) : payment.planDetails.licenseduser,
            "upgrade_basic_user_count": product[0].double_up == 1 ? (parseInt(payment.planDetails.licenseduser) * 2) : payment.planDetails.licenseduser,
            "p_platform_user_fee": localStorage.getItem("platformfee"),
            "p_platform_user_count": localStorage.getItem("conversationCount")
        }
        await ApiServices.post(_body, _url);
        setLoader(false)
    }


    const handlePayment = async (plan: any, plantype: any, planPricing: any, minimumUsers: any, planId: any, maximumUsers: any) => {
        localStorage.setItem("planName", plan);
        localStorage.setItem("planType", plantype);
        localStorage.setItem("planId", planId);
        localStorage.setItem("planPricing", planPricing);
        localStorage.setItem("minimumUsers", minimumUsers);
        localStorage.setItem("maximumUsers", maximumUsers);
        localStorage.setItem("fullUsers", minimumUsers);
        var flag = true;
        if (!authIsChecked) {
            setIsCheckError(true)
            alert("Please authorise")
            return false
        }


        //save plan details
        const rate_body = {
            licenseduser: licenseUser,
            taxPer: 20,
            vatCal: vat,
            total: user?.paymentBotData?.detail?.companyId == 19538 ? newcomp : total,
            planId: user?.getPlanInfo[0].tier_id,
            planPrice: user?.getPlanInfo[0].cop_description == '1 month' ? user?.getPlanInfo[0].price1 : user?.getPlanInfo[0].cop_description == '12 months' ? user?.getPlanInfo[0].price2 : user?.getPlanInfo[0].price1,
            Duration: user?.paymentBotData?.detail?.duration,
            freeToPaid: products[0].free_Paid == 1 ? "Yes" : "No"
        }
        console.log("Rate body", rate_body)
        dispatch(setPlanDetails(rate_body))
        setPaymentModal(true);
        setTimeout(() => {
            setCardStatus('')
        }, 3000);


    }
    const onPaymentResult = async (obj) => {
        console.log("payment func", obj, obj.paymentIntent)
        setPaymentModal(false);
        setLoader(true);

        if (obj?.status == "failed") {
            setCardStatus("Payment Failed")
            setTimeout(() => {
                setCardStatus('')
            }, 3000);
            setLoader(false);
            return;
        } else if (obj?.status == "succeeded") {
            await dispatch(paymentserviceNumbersStep1Result({ Ref_Id: obj?.paymentIntent?.id, subscriptionId: obj?.paymentIntent?.id }));
            if (product[0].sec_prod_id != null) {
                secondaryPlanUpgrade(obj?.paymentIntent?.id);
            } else {
                planUpgradeRequest(obj?.paymentIntent?.id);
                console.log("res.data", obj.paymentIntent)
            }
        } else {
            setCardStatus("Payment Failed")
            setTimeout(() => {
                setCardStatus('')
            }, 3000);
            setLoader(false);

        }

    }


    const [getIndex, setIndex] = useState<any>(0);
    const [getInFrom, setInFrom] = useState<any>('');

    // const handleCheckboxChange1 = (event: any, i: any) => {
    //     const isChecked = event.target.checked;
    //     setIndex(i)
    //     setIsChecked(isChecked)
    //     setInFrom(savedCardDetails[i])
    // }




    // const currencyConverterApi = async () => {
    //     let _url = API_ROUTE_CONTROLLER.currencyConversion;
    //     let _body = {
    //         amount: product[0]?.company_id == 19538 ? newcomp: total
    //     }
    //     let conversion = await ApiServices.post(_body, _url)
    //     console.log("conversion", conversion.data.conversionAmount)
    //     return conversion.data.conversionAmount
    // }

    useEffect(() => {
        if (product[0].Is_free_trail == 1) {
            setLicenseUser(0);
        } else {
            setLicenseUser(localStorage.getItem("minimumUsers"));
        }
        setMinUserPlan(localStorage.getItem("minimumUsers"));
        setMaxUserPlan(localStorage.getItem("maximumUsers"));
        setPlatform_fee(localStorage.getItem("platformfee"));

        user_type();
        getSavedCard();
        getCountryList();
        getUserData();
        const int = async () => {
            const billServicePlan = await getBillServicePlan();
            localStorage.setItem("previousplanid", billServicePlan.result[0].plan_id)
            localStorage.setItem("previousplanprice", billServicePlan.result[0].current_plan_price)

            setPlanName(billServicePlan.result[0].pln_name)
            const nextBillDate = billServicePlan.result[0].bill_cycle.split("-")
            localStorage.setItem("nextbilldate", nextBillDate[1].trim())
            const dur1: any = user?.paymentBotData?.detail?.duration == "1 month";
            const dur12: any = user?.paymentBotData?.detail?.duration == "12 months";
            console.log("user?.getPlanInfo[0].tier_id && dur1 && product[0].Is_free_trail == 0",user?.getPlanInfo[0].tier_id , dur1 , product[0].Is_free_trail)
            if (user?.getPlanInfo[0].tier_id && dur1 && product[0].Is_free_trail == 0) {
                console.log("duration1 month")
                const previousUserCount: any = localStorage.getItem("previousUserCount");
                const getPreviUserCount: any = previousUserCount;
                setAValue(parseInt(licenseUser))
                const getPreviPlanPrice: any = localStorage.getItem("previousplanprice");
                const date122: any = localStorage.getItem("nextbilldate");
                const targetDate: any = new Date(date122);
                const currentDate: any = new Date();
                const diffInMs: any = targetDate.getTime() - currentDate.getTime();
                const diffInDays: any = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
                console.log("diffInDaysdiffInDays123", diffInDays, getPreviUserCount, getPreviPlanPrice);
                const b: any = ((((parseInt(getPreviUserCount)) * parseInt(getPreviPlanPrice)) / 30) * diffInDays)
                setBValue(b)
                if (isChecked1 == true) {
                    console.log("bbbbbbbbbbbb", b, user?.getPlanInfo[0].price2, parseInt((licenseUser)), userBaiscCount)
                    const vatCal: any = (parseInt(user?.getPlanInfo[0].platform_fee))
                    console.log("vatCalvatCal", vatCal)
                    const vatCal1: any = ((parseInt(vatCal)) * 0.2)
                    console.log("vatCal: " + vatCal1)
                    setVat(vatCal1)
                    let total1 = parseInt(user?.getPlanInfo[0].platform_fee)
                    console.log("total1", total1)
                    setTotal(vatCal1 + (parseInt(vatCal)))
                } else if (isChecked1 == false) {
                    console.log("bbbbbbbbbbbb", b, user?.getPlanInfo[0].price2, parseInt((licenseUser)), userBaiscCount)
                    const vatCal: any = (parseInt(user?.getPlanInfo[0].platform_fee))
                    console.log("vatCalvatCal", vatCal)
                    const vatCal1: any = ((parseInt(vatCal)) * 0.2)
                    console.log("vatCal: " + vatCal1)
                    setVat(vatCal1)
                    let total1 = user?.getPlanInfo[0].price2 * (parseInt((licenseUser)))
                    console.log("total1", total1)
                    setTotal(vatCal1 + (parseInt(vatCal)))
                }

            } else if (user?.getPlanInfo[0].tier_id && dur12 && product[0].Is_free_trail == 0) {
                console.log("duration12")
                const getEnterpriceUser: any = localStorage.getItem("minimumUsers");
                const getEnterpriceAmt: any = localStorage.getItem("planPricing");
                const previousUserCount: any = localStorage.getItem("previousUserCount");
                const getPreviUserCount: any = previousUserCount;
                setAValue(parseInt(licenseUser))
                const getPreviPlanPrice: any = localStorage.getItem("previousplanprice");
                const date122: any = localStorage.getItem("nextbilldate");
                const targetDate: any = new Date(date122);
                const currentDate: any = new Date();
                const diffInMs: any = targetDate.getTime() - currentDate.getTime();
                const diffInDays: any = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
                console.log("diffInDaysdiffInDays12345", diffInDays, getPreviUserCount, getPreviPlanPrice);
                const b: any = ((((parseInt(getPreviUserCount)) * parseInt(getPreviPlanPrice)) / 30) * diffInDays)
                setBValue(b)
                if (isChecked1 == true) {
                    console.log("bbbbbbbbbbbb", b, user?.getPlanInfo[0].price2, parseInt((getPreviUserCount)), userBaiscCount)
                    const vatCal: any = (parseInt(user?.getPlanInfo[0].platform_fee))
                    console.log("vatCalvatCal", vatCal)
                    const vatCal1: any = ((parseInt(vatCal)) * 0.2)
                    console.log("vatCal: " + vatCal1)
                    setVat(vatCal1)
                    let total1 = user?.getPlanInfo[0].price2 * (parseInt((getPreviUserCount)) + parseInt(userBaiscCount ? userBaiscCount : 0))
                    console.log("total1", total1)
                    setTotal(vatCal1 + (parseInt(vatCal)))
                } else if (isChecked1 == false) {
                    console.log("bbbbbbbbbbbb", b, user?.getPlanInfo[0].price2, parseInt((getPreviUserCount)))
                    const vatCal: any = (user?.getPlanInfo[0].platform_fee)
                    console.log("vatCalvatCal", vatCal)
                    const vatCal1: any = ((parseInt(vatCal)) * 0.2)
                    console.log("vatCal: " + vatCal1)
                    setVat(vatCal1)
                    let total1 = user?.getPlanInfo[0].price2 * (parseInt((getPreviUserCount)))
                    console.log("total1", total1)
                    setTotal(vatCal1 + (parseInt(vatCal)))
                }
            }
        }
        int();
        const rate_body = {
            licenseduser: licenseUser,
            taxPer: 20,
            vatCal: vatCal,
            total: user?.paymentBotData?.detail?.companyId == 19538 ? newcomp : total,
            planId: user?.getPlanInfo[0]?.tier_id,
            planPrice: user?.getPlanInfo[0].cop_description == '1 month' ? user?.getPlanInfo[0].price1 : user?.getPlanInfo[0].cop_description == '12 months' ? user?.getPlanInfo[0].price2 : user?.getPlanInfo[0].price1,
            // duration: user?.getPlanInfo[0]?.cop_description,
            duration: localStorage.getItem("durations"),
            freeToPaid: products[0].free_Paid == 1 ? "Yes" : "No"
        }
        dispatch(setPlanDetails(rate_body))

        if (user?.getDataEnterFromAddCardUpdate?.dataEnter?.status === true) {
            IsAddNewCard(false)
        }
    }, [])

    // useEffect(() => {
    //     if (setUpFee === "1") {

    //         var vatCal = (parseInt(installationCost)) * 0.2
    //         setVat(vatCal)
    //         setTotal(vatCal + (parseInt(installationCost)))
    //     } else {
    //         var vatCal = (user?.getPlanInfo[0]?.platform_fee) * 0.2
    //         setVat(vatCal)
    //         setTotal(vatCal + ((parseInt(user?.getPlanInfo[0].platform_fee))))

    //     }
    // })

    const shopfifyModal = () => {
        setShopifyRedirectModal(!isShopifyRedirectModal);
    }

    // const redirectToShopify = async () => {

    //     let amount = await currencyConverterApi()
    //     console.log("amount", amount)
    //     let choosedProductPlan: any = user;
    //     console.log("choosedProductPlan-----", choosedProductPlan);
    //     console.log("product-----------", product);

    //     console.log("redirect to shopify");
    //     let payloads = {

    //         planName: choosedProductPlan.getPlanInfo[0].tier_name,
    //         price: amount,
    //         returnUrl: 'https://myaccount.worktual.co.uk/shopifyPaySuccess'
    //     }
    //     let shopifyStoreData: any;
    //     if (Array.isArray(product) && product[0].shopifyid !== '0') {
    //         shopifyStoreData = product[0].shopifyid;
    //     }
    //     else {
    //         return true;
    //     }

    //     const headers = {
    //         Authorization: shopifyStoreData
    //     }

    //     console.log("payloads----------------", payloads);
    //     await axios.post("https://ccaasapi.worktual.co.uk/connector/shopify/v1/recurringApplicationCharge", payloads, { headers }).then((recursionResp) => {
    //         console.log("data-------", recursionResp.data);
    //         window.location.href = recursionResp.data.recurring_application_charge.confirmation_url;

    //     }).catch((err) => {
    //         console.log("err", err);

    //     })

    // }

    return (
        <>
            <Row className="breadcrumbarea">
                <Col sm={12}>
                    <h4>Upgrade</h4>
                    <p>Upgrade plan based on your preference.</p>
                </Col>
            </Row>

            <div className={styles.scrolldiv}>

                < div className={`${styles.paymenttable} ${styles.basicupgrade}`}>
                    <Col sm={12}>
                        <h5>{user?.getPlanInfo[0]?.tier_name} Plan Upgrade</h5>
                                {/* <ul>
                                    <li>{user?.getPlanInfo[0]?.summary_list ? user?.getPlanInfo[0]?.summary_list.split('|')[0] : ""}</li>
                                    <li>{user?.getPlanInfo[0]?.summary_list ? user?.getPlanInfo[0]?.summary_list.split('|')[1] : ""}</li>
                                </ul> */}
                           
                        {
                            product[0].product_id == 1 ?
                                <>
                                    <label className={styles.fieldarea}>
                                        <span>Purchase New Licenses<sub></sub></span>
                                        <input type="text" name='' placeholder="Enter License Users"
                                            min={typeof minUserPlan != "undefined" ? minUserPlan : 6}
                                            max={(typeof maxUserPlan != "undefined") ? maxUserPlan : 99}
                                            onChange={onLicenseUserChange}
                                            value={licenseUser}
                                            onPaste={(e: any) => { e.preventDefault(); return false; }}
                                            onCopy={(e: any) => { e.preventDefault(); return false; }}
                                            onBlur={() => setLicenseUserErr("")}
                                            onKeyPress={onKeyPressEvent}
                                            readOnly
                                        />
                                    </label>
                                    <p className="fieldareaerror"> {getLicenseUserErr ? <>{getLicenseUserErr}</> : ""}</p>
                                </> : <></>
                        }



                    </Col>
                </div>
                {total == 0 ? "" :
                    <div className={styles.paymenttable}>
                        <Col sm={12} className="nopadding paddinghalf">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Description</th>
                                        {/* <th>Qty</th> */}
                                        {/* <th>Unit Price</th> */}
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                {product[0].Is_free_trail != 0 ?
                                    <tbody>
                                        {setUpFee == "1" ?
                                            <tr>
                                                {/* <td></td> */}
                                                {/* <td></td> */}
                                                <td><h6>Set-Up Fee</h6></td>
                                                <td>{COUNTRY.CURRENCY}{parseInt(installationCost).toFixed(2)}</td>
                                            </tr> :

                                            <tr>
                                                {/* <td></td> */}
                                                {/* <td></td> */}
                                                <td>License Fee</td>
                                                <td>{COUNTRY.CURRENCY}{parseInt(user?.getPlanInfo[0].platform_fee).toFixed(2)}</td>
                                            </tr>
                                        }

                                        <tr>
                                            {
                                                isChecked1 == true ?
                                                    <>
                                                        <td>Basic User Upgrade</td>
                                                        {/* <td>{userBaiscCount}</td> */}
                                                        {
                                                            user?.getPlanInfo[0]?.cop_description == '12 months' ?
                                                                <td>{user?.getPlanInfo[0]?.price2}</td>
                                                                : user?.getPlanInfo[0]?.cop_description == '1 month' ?
                                                                    <td>{user?.getPlanInfo[0]?.price1}</td>
                                                                    : <td>{user?.getPlanInfo[0]?.price1}</td>
                                                        }
                                                        {
                                                            user?.getPlanInfo[0]?.cop_description == '12 months' ?
                                                                <td>{COUNTRY.CURRENCY}{(user?.getPlanInfo[0]?.price2 * userBaiscCount).toFixed(2)}</td>
                                                                : user?.getPlanInfo[0]?.cop_description == '1 month' ?
                                                                    <td>{COUNTRY.CURRENCY}{(user?.getPlanInfo[0]?.price1 * userBaiscCount).toFixed(2)}</td>
                                                                    : <td>{COUNTRY.CURRENCY}{(user?.getPlanInfo[0]?.price1 * userBaiscCount).toFixed(2)}</td>
                                                        }

                                                    </>
                                                    : <></>
                                            }

                                        </tr>

                                        {user?.paymentBotData?.detail?.companyId == 19538 ?
                                            <>

                                                <tr>
                                                    {/* <td></td> */}
                                                    {/* <td></td> */}
                                                    <td><h6>Discount</h6></td>
                                                    <td>{COUNTRY.CURRENCY}{Math.round((parseInt(user?.getPlanInfo[0].platform_fee) * (discountNew)))}</td>
                                                </tr>
                                                <tr>
                                                    {/* <td></td> */}
                                                    {/* <td></td> */}
                                                    <td><h6>After Discount License Fee</h6></td>
                                                    <td>{COUNTRY.CURRENCY}{Math.round(parseInt(user?.getPlanInfo[0].platform_fee) - (parseInt(user?.getPlanInfo[0].platform_fee) * (discountNew)))}</td>
                                                </tr>
                                                <tr>
                                                    {/* <td></td> */}
                                                    {/* <td></td> */}
                                                    <td><h6>Set-Up Fee</h6></td>
                                                    <td>{COUNTRY.CURRENCY}{Math.round(parseInt(user?.getPlanInfo[0].Installation_cost))}</td>
                                                </tr>
                                                <tr>
                                                    {/* <td></td> */}
                                                    {/* <td></td> */}
                                                    <td><h6>Subtotal Excl VAT</h6></td>
                                                    {
                                                        setUpFee === "1" ?
                                                            <>
                                                                {
                                                                    user?.getPlanInfo[0]?.cop_description == '12 months' ?
                                                                        <td>{COUNTRY.CURRENCY}{(parseInt(installationCost)).toFixed(2)}</td>
                                                                        : user?.getPlanInfo[0]?.cop_description == '1 month' ?
                                                                            <td>{COUNTRY.CURRENCY}{(parseInt(installationCost)).toFixed(2)}</td>
                                                                            : <td>{COUNTRY.CURRENCY}{(parseInt(installationCost)).toFixed(2)}</td>
                                                                }
                                                            </> :
                                                            <>
                                                                {
                                                                    user?.getPlanInfo[0]?.cop_description == '12 months' ?
                                                                        <td>{COUNTRY.CURRENCY}{
                                                                            Math.round(
                                                                                parseInt(user?.getPlanInfo[0].platform_fee) +
                                                                                parseInt(user?.getPlanInfo[0].Installation_cost) -
                                                                                (parseInt(user?.getPlanInfo[0].platform_fee) * discountNew)
                                                                            )
                                                                        }</td>
                                                                        : user?.getPlanInfo[0]?.cop_description == '1 month' ?
                                                                            <td>{COUNTRY.CURRENCY}{
                                                                                Math.round(
                                                                                    parseInt(user?.getPlanInfo[0].platform_fee) +
                                                                                    parseInt(user?.getPlanInfo[0].Installation_cost) -
                                                                                    (parseInt(user?.getPlanInfo[0].platform_fee) * discountNew)
                                                                                )
                                                                            }</td>
                                                                            : <td>{COUNTRY.CURRENCY}{
                                                                                Math.round(
                                                                                    parseInt(user?.getPlanInfo[0].platform_fee) +
                                                                                    parseInt(user?.getPlanInfo[0].Installation_cost) -
                                                                                    (parseInt(user?.getPlanInfo[0].platform_fee) * discountNew)
                                                                                )
                                                                            }</td>
                                                                }
                                                            </>
                                                    }

                                                </tr>

                                                <tr>
                                                    {/* <td></td> */}
                                                    {/* <td></td> */}
                                                    <td><h6>Value Added Tax - 20%</h6></td>
                                                    <td>{COUNTRY.CURRENCY}{Math.round(
                                                        (parseInt(user?.getPlanInfo[0].platform_fee) +
                                                            parseInt(user?.getPlanInfo[0].Installation_cost) -
                                                            (parseInt(user?.getPlanInfo[0].platform_fee) * discountNew)) * 0.2
                                                    )}</td>
                                                </tr>
                                                <tr>
                                                    {/* <td></td> */}
                                                    {/* <td></td> */}
                                                    <td><h5>Total Inc VAT</h5></td>
                                                    <td><h5>{COUNTRY.CURRENCY}{Math.round((
                                                        (parseInt(user?.getPlanInfo[0].platform_fee) +
                                                            parseInt(user?.getPlanInfo[0].Installation_cost) -
                                                            (parseInt(user?.getPlanInfo[0].platform_fee) * discountNew)) * 0.2
                                                    )) + Math.round((
                                                        parseInt(user?.getPlanInfo[0].platform_fee) +
                                                        parseInt(user?.getPlanInfo[0].Installation_cost) -
                                                        (parseInt(user?.getPlanInfo[0].platform_fee) * discountNew)
                                                    ))}</h5></td>
                                                </tr>
                                                <tr>
                                                    {/* <td></td> */}
                                                    {/* <td></td> */}
                                                    <td><h5>Total Charged to Credit Card</h5></td>
                                                    <td><h5>{COUNTRY.CURRENCY}{Math.round((
                                                        (parseInt(user?.getPlanInfo[0].platform_fee) +
                                                            parseInt(user?.getPlanInfo[0].Installation_cost) -
                                                            (parseInt(user?.getPlanInfo[0].platform_fee) * discountNew)) * 0.2
                                                    )) + Math.round((
                                                        parseInt(user?.getPlanInfo[0].platform_fee) +
                                                        parseInt(user?.getPlanInfo[0].Installation_cost) -
                                                        (parseInt(user?.getPlanInfo[0].platform_fee) * discountNew)
                                                    ))}</h5></td>
                                                </tr>
                                            </> : <>


                                                <tr>
                                                    {/* <td></td> */}
                                                    {/* <td></td> */}
                                                    <td><h6>Subtotal Excl VAT</h6></td>
                                                    {
                                                        setUpFee === "1" ?
                                                            <>
                                                                {
                                                                    user?.getPlanInfo[0]?.cop_description == '12 months' ?
                                                                        <td>{COUNTRY.CURRENCY}{(parseInt(installationCost)).toFixed(2)}</td>
                                                                        : user?.getPlanInfo[0]?.cop_description == '1 month' ?
                                                                            <td>{COUNTRY.CURRENCY}{(parseInt(installationCost)).toFixed(2)}</td>
                                                                            : <td>{COUNTRY.CURRENCY}{(parseInt(installationCost)).toFixed(2)}</td>
                                                                }
                                                            </> :
                                                            <>
                                                                {
                                                                    user?.getPlanInfo[0]?.cop_description == '12 months' ?
                                                                        <td>{COUNTRY.CURRENCY}{(parseInt(user?.getPlanInfo[0].platform_fee)).toFixed(2)}</td>
                                                                        : user?.getPlanInfo[0]?.cop_description == '1 month' ?
                                                                            <td>{COUNTRY.CURRENCY}{(parseInt(user?.getPlanInfo[0].platform_fee)).toFixed(2)}</td>
                                                                            : <td>{COUNTRY.CURRENCY}{(parseInt(user?.getPlanInfo[0].platform_fee)).toFixed(2)}</td>
                                                                }
                                                            </>
                                                    }

                                                </tr>

                                                <tr>
                                                    {/* <td></td> */}
                                                    {/* <td></td> */}
                                                    <td><h6>Value Added Tax - 20%</h6></td>
                                                    <td>{COUNTRY.CURRENCY}{vat.toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    {/* <td></td> */}
                                                    {/* <td></td> */}
                                                    <td><h5>Total Inc VAT</h5></td>
                                                    <td><h5>{COUNTRY.CURRENCY}{(total.toFixed(2))}</h5></td>
                                                </tr>
                                                <tr>
                                                    {/* <td></td> */}
                                                    {/* <td></td> */}
                                                    <td><h5>Total Charged to Credit Card</h5></td>
                                                    <td><h5>{COUNTRY.CURRENCY}{(total.toFixed(2))}</h5></td>
                                                </tr>
                                            </>
                                        }

                                    </tbody>

                                    : //----------------------------------------------------
                                    <tbody>

                                        {setUpFee == "1" ?
                                            <tr>
                                                {/* <td></td> */}
                                                {/* <td></td> */}
                                                <td><h6>Set-Up Fee</h6></td>
                                                <td>{COUNTRY.CURRENCY}{parseInt(installationCost).toFixed(2)}</td>
                                            </tr> :

                                            <tr>
                                                {/* <td></td> */}
                                                {/* <td></td> */}
                                                <td>License Fee</td>
                                                <td>{COUNTRY.CURRENCY}{parseInt(user?.getPlanInfo[0].platform_fee).toFixed(2)}</td>
                                            </tr>
                                        }

                                        <tr>
                                            {/* <td></td> */}
                                            {/* <td></td> */}
                                            <td><h6>Subtotal Excl VAT</h6></td>
                                            {
                                                setUpFee === "1" ?
                                                    <>
                                                        {
                                                            user?.getPlanInfo[0]?.cop_description == '12 months' ?
                                                                <td>{COUNTRY.CURRENCY}{(parseInt(installationCost)).toFixed(2)}</td>
                                                                : user?.getPlanInfo[0]?.cop_description == '1 month' ?
                                                                    <td>{COUNTRY.CURRENCY}{(parseInt(installationCost)).toFixed(2)}</td>
                                                                    : <td>{COUNTRY.CURRENCY}{(parseInt(installationCost)).toFixed(2)}</td>
                                                        }
                                                    </> :
                                                    <>
                                                        {
                                                            user?.getPlanInfo[0]?.cop_description == '12 months' ?
                                                                <td>{COUNTRY.CURRENCY}{(parseInt(user?.getPlanInfo[0].platform_fee)).toFixed(2)}</td>
                                                                : user?.getPlanInfo[0]?.cop_description == '1 month' ?
                                                                    <td>{COUNTRY.CURRENCY}{(parseInt(user?.getPlanInfo[0].platform_fee)).toFixed(2)}</td>
                                                                    : <td>{COUNTRY.CURRENCY}{(parseInt(user?.getPlanInfo[0].platform_fee)).toFixed(2)}</td>
                                                        }
                                                    </>
                                            }

                                        </tr>

                                        <tr>
                                            {/* <td></td> */}
                                            {/* <td></td> */}
                                            <td><h6>Value Added Tax - 20%</h6></td>
                                            <td>{COUNTRY.CURRENCY}{vat.toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            {/* <td></td> */}
                                            {/* <td></td> */}
                                            <td><h5>Total Inc VAT</h5></td>
                                            <td><h5>{COUNTRY.CURRENCY}{(total.toFixed(2))}</h5></td>
                                        </tr>
                                        <tr>
                                            {/* <td></td> */}
                                            {/* <td></td> */}
                                            <td><h5>Total Charged to Credit Card</h5></td>
                                            <td><h5>{COUNTRY.CURRENCY}{(total.toFixed(2))}</h5></td>
                                        </tr>
                                    </tbody>
                                }

                            </table>



                            {/* {
    setUpFee === "1" ? <>
                                {!isCheckError ?
                                <label className="checkbox-button">
                                    <input type="checkbox" className="checkbox-button__input" id="choice1-1" name="choice1" onClick={handleCheckboxChange} />
                                    <span className="checkbox-button__control"></span>
                                    <span className="checkbox-button__label">I authorise to be charged the amount of {COUNTRY.CURRENCY}{product[0]?.company_id == 19538 ? newcomp: total}. I acknowledge that I have read this information and understand the itemized charges listed above. 
                                        </span>
                                </label> :
                                <label className="checkbox-button">
                                    <input type="checkbox" className="checkbox-button__input" id="choice1-1" name="choice1" onClick={handleCheckboxChange} />
                                    <span className="checkbox-button__control"></span>
                                    <span className="checkbox-button__label">I authorise to be charged the amount of {COUNTRY.CURRENCY}{product[0]?.company_id == 19538 ? newcomp: total}. I acknowledge that I have read this information and understand the itemized charges listed above. 
                                        </span>
                                </label>}
    </> : <> */}
                            {!isCheckError ?
                                <label className="checkbox-button">
                                    <input type="checkbox" className="checkbox-button__input" id="choice1-1" name="choice1" onClick={handleCheckboxChange} />
                                    <span className="checkbox-button__control"></span>
                                    <span className="checkbox-button__label">I authorise to be charged the amount of {COUNTRY.CURRENCY}{user?.paymentBotData?.detail?.companyId == 19538 ? newcomp : total}. I acknowledge that I have read this information and understand the itemized charges listed above.
                                        I further authorise the monthly recurring charges of {COUNTRY.CURRENCY}{user?.paymentBotData?.detail?.companyId == 19538 ? newcomp : total} begining on  {moment(new Date()).format("DD/MM/YYYY")} and continuing until cancelled.
                                    </span>
                                </label> :
                                <label className="checkbox-button">
                                    <input type="checkbox" className="checkbox-button__input" id="choice1-1" name="choice1" onClick={handleCheckboxChange} />
                                    <span className="checkbox-button__control"></span>
                                    <span className="checkbox-button__label">I authorise to be charged the amount of {COUNTRY.CURRENCY}{user?.paymentBotData?.detail?.companyId == 19538 ? newcomp : total}. I acknowledge that I have read this information and understand the itemized charges listed above.
                                        I further authorise the monthly recurring charges of {COUNTRY.CURRENCY}{user?.paymentBotData?.detail?.companyId == 19538 ? newcomp : total} begining on {moment(new Date()).format("DD/MM/YYYY")} and continuing until cancelled.
                                    </span>
                                </label>}
                            {/* </>
} */}


                            <br />
                        </Col>
                    </div>
                }


            </div >
            {total == 0 ?
                <Row className={styles.bottomarea}>
                    <Col sm={12} className={styles.bottomareainner}>
                        <button className="cancelbtn" onClick={() => navigation()}>Cancel</button>
                        <button onClick={NewProductPurchaseApi} >Finish</button>


                    </Col>
                </Row> :
                <Row className={styles.bottomarea}>
                    <Col sm={12} className={styles.bottomareainner}>
                        <button className="cancelbtn" onClick={() => navigation()}>Cancel</button>
                        <button onClick={() => !product[0].shopifyid ? handlePayment(user?.getPlanInfo[2]?.tier_name, user?.getPlanInfo[2]?.price1 == 0 ? 1 : 0, user?.getPlanInfo[2]?.price2 == 0 ? user?.getPlanInfo[2]?.price1 : user?.getPlanInfo[2]?.price2, user?.getPlanInfo[2]?.min_user, user?.getPlanInfo[2]?.tier_id, user?.getPlanInfo[2]?.max_user == 0 ? 9999 : user?.getPlanInfo[2]?.max_user)
                            : shopfifyModal()

                        } >Confirm Payment</button>

                    </Col>
                </Row>
            }

            {/* <Modal show={modalShow} onHide={handleClose} className="modaldefaults" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Select Card</Modal.Title>
                </Modal.Header>
                <Modal.Body className='modalbigspace'>

                    <div className="forcardsin">
                        {savedCardDetails && savedCardDetails.map((item, index) =>
                            item ? (
                                <label className={styles.selectdiv}>
                                    <input type="radio" name="myCheckbox" onChange={(e) => handleCheckboxChange1(e, index)} />
                                    <div className={`${styles.addonsmain} ${styles.modelcard}`}>
                                        <div className={styles.lefts}>
                                            <img src={masterlogo} />
                                            <div className={styles.addondetails}>
                                                <h5>xxxx xxxx xxxx {item.cc_no} {item.is_card_default_desc == 'Primary card' ? <span>Primary</span> : ""}</h5>
                                                <p>Lorem ipsum</p>
                                            </div>
                                        </div>
                                    </div>
                                </label>
                            ) : ''
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <p onClick={handleShownew}><span className="cardplus">+</span>Add Card</p>
                    <button onClick={handleClose} className="cancelbtn">Cancel</button>
                    {
                        savedCardDetails.length == 0 ? "" :
                            <>
                                <button onClick={handleSelectCard}>Select Card</button>
                            </>
                    }

                </Modal.Footer>
            </Modal> */}

            {/* {cardStatus ? <ToastError errorMsg={cardStatus}></ToastError> : <> </>} */}


            {/* <Modal show={modalShownew} onHide={handleClosenew} className="modaldefaults" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Add Card</Modal.Title>
                </Modal.Header>
                <Modal.Body className='modalbigspace'>

                    <label className={styles.fieldarea}>
                        <span>Name on card<sub>*</sub></span>
                        <input type="text" name="card_name" placeholder=""
                            onKeyDown={(event) => {
                                const allowedKeys = /^[a-zA-Z\s]*$/;
                                if (!allowedKeys.test(event.key)) {
                                    event.preventDefault();
                                }
                            }} onChange={handleChange} />
                    </label>
                    {isSubmitted && formErrors.card_name && (
                        <span className="fieldareaerror">{formErrors.card_name}</span>
                    )}

                    <label className={styles.fieldarea}>
                        <span>Card Number<sub>*</sub></span>
                        <input type="text" name="card_number" maxLength={19} value={cardNumber} placeholder="" onChange={handleChange} />
                    </label>

                    <label className={styles.fieldareasmall}>
                        <span></span>
                        <p>Supported Cards : <img src={allcards} /></p>
                    </label>
                    {isSubmitted && formErrors.card_number && (
                        <span className="fieldareaerror">{formErrors.card_number}</span>
                    )}
                    
                    <label className={styles.fieldarea}>
                        <span>Expiry Date<sub>*</sub></span>
                        <select id="date" name="exp_date" value={getMonth} onChange={handleChange}>
                            <option value="">Select month</option>
                            {Array.from({ length: 12 }, (_, index) => index + 1).map((month) => (
                                <option key={month} value={month.toString().padStart(2, '0')}>
                                    {month.toString().padStart(2, '0')}
                                </option>
                            ))}
                        </select>
                        <select id="year" name="exp_year" value={getYear} onChange={handleChange}>
                            <option value="">Select year</option>
                            {yearOptions.map((year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            ))}
                        </select>
                    </label>
                    {isSubmitted && formErrors.exp_year && (
                        <span className="fieldareaerror">{formErrors.exp_year}</span>
                    )}
                    <br />
                    {isSubmitted && getValue.exp_date === '' && (
                        <span className="fieldareaerror">{formErrors.exp_date}</span>
                    )}


                  
                    <label className={styles.fieldarea}>
                        <span>Address<sub>*</sub></span>
                        <input type="text" name="address" placeholder="" onChange={handleChange} />
                    </label>
                    {isSubmitted && formErrors.address && (
                        <span className="fieldareaerror">{formErrors.address}</span>
                    )}

                    <label className={styles.fieldarea}>
                        <span>City<sub>*</sub></span>
                        <input type="text" name="city" placeholder="" onChange={handleChange} />
                    </label>
                    {isSubmitted && formErrors.city && (
                        <span className="fieldareaerror">{formErrors.city}</span>
                    )}

                    <label className={styles.fieldarea}>
                        <span>Country<sub>*</sub></span>
                        <select id="text" name="country" placeholder="select country" onChange={handleChange}>
                            <option value="">Select country</option>
                            {getCountryListData && getCountryListData.map((country: any) => (
                                <option key={country} value={country.country_name}>{country.country_name}</option>
                            )
                            )}
                        </select>
                    </label>
                    {isSubmitted && formErrors.country && (
                        <span className="fieldareaerror">{formErrors.country}</span>
                    )}

                    <label className={styles.fieldarea}>
                        <span>Post Code<sub>*</sub></span>
                        <input type="text" name="postcode" placeholder="" onChange={handleChange} />
                    </label>
                    {isSubmitted && formErrors.postcode && (
                        <span className="fieldareaerror">{formErrors.postcode}</span>
                    )}

                </Modal.Body>
                <Modal.Footer>
                    <button onClick={handleClosenew} className="cancelbtn" >Cancel</button>
                    <button onClick={handleStore}>Add</button>
                </Modal.Footer>
            </Modal>

            <Modal show={isShopifyRedirectModal} maskClosable={false} className="modaldefaults" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Approve Subscription</Modal.Title>
                </Modal.Header>
                <Modal.Body className='modalbigspace'>
                    Your payment process has been initiated. Kindly, Redirect to Shopify to proceed further.
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={shopfifyModal} className="cancelbtn" >Not Now</button>
                    <button onClick={redirectToShopify}>Continue in Shopify</button>
                </Modal.Footer>
            </Modal> */}



            <Modal show={paymentModal} maskClosable={false} onHide={() => setPaymentModal(false)} className="modaldefaults paymentmodel modalminheight" backdrop="static">
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body className='modalbigspace'>
                    <Stripe amount={total} onPaymentResult={onPaymentResult} />
                </Modal.Body>

            </Modal>




            {isLoader == true ? <Loaders></Loaders> : ""}

        </>
    );
};
export default ChatBotPlanDetailsBot;